import { MAX_PASSWORD_STRENGTH } from "./const"
import stringEntropy from 'fast-password-entropy'
import { Stage, Template } from "./types"

// @ts-ignore
Array.prototype.get = function <T>(this: T, idx: number): T {
    return this[idx]
}

export const isServer = (typeof window === `undefined`)

type ISiteDeploymentType = 'development' | 'staging' | 'production'
export const SiteDeploymentType = (): ISiteDeploymentType => {
    if (isServer) {
        return (process.env.SITE_DEPLOYMENT_TYPE || process.env.NODE_ENV || 'development') as ISiteDeploymentType
    } else {
        // @ts-expect-error
        return SITE_DEPLOYMENT_TYPE ? SITE_DEPLOYMENT_TYPE : 'development'
    }
}

export function validateEmail(email: string) {
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    return re.test(String(email).toLowerCase())
}

export const GetPasswordStrength = (password): number => {
    return Math.min(100, Math.round((stringEntropy(password) / MAX_PASSWORD_STRENGTH) * 100))
}

// #region Event

const getEventStageAgendaMD = (stage: Stage, stageIndex: number) => {
    var agenda = `\n ### ${(stageIndex > -1 ? `${stageIndex + 1}. ` : '')} ${stage.name}: ${stage.description}`

    'steps' in stage?.options && stage.options.steps.length > 1 ? stage.options.steps.forEach((step, stepIndex) => {
        agenda += `\n #### ${stepIndex + 1}. ${step.name}: ${step.description}`
    }
    ) : null

    return agenda
}
export const getEventAgendaMD = (template: Template) => {
    if (!template) return null

    let eventAgendaMD = ""
    eventAgendaMD += `\n# Agenda: ${template.name}`

    {
        template.groups && template.groups.length > 0 ? (
            template.groups.forEach((group, groupIndex) => {

                eventAgendaMD += `\n## ${(groupIndex > -1 ? `${groupIndex + 1}. ` : '')} ${group.name}: ${group.description ? group.description : ""}`

                template.stages.filter(stage => stage.group === group.id)
                    .forEach((stage, stageIndex) => {
                        eventAgendaMD += getEventStageAgendaMD(stage, stageIndex)
                    })
            })
        ) : (
            // Render Stages directly if there are no Stage Groups
            template.stages.forEach((stage, stageIndex) => {
                eventAgendaMD += getEventStageAgendaMD(stage, stageIndex)
            })
        )
    }

    return eventAgendaMD
}

/**
 * This function takes a description string as input and returns an array of bullet points.
 * It is shared between report generation and client components like the ai co-facilitator and results views.
 * 
 * @param {string} description - The event description string.
 * @returns {string[]} - An array of bullet points derived from the description.
 * 
 * The function works as follows:
 * 1. It splits the description string into separate lines based on punctuation marks (., !, ?) followed by one or more spaces, or a newline character.
 * 2. It then maps over each line, removing any leading numbers, dots, hyphens, asterisks, or bullet points, and trims any leading or trailing whitespace.
 */
export const getEventDescriptionBulletPoints = (description: string): string[] => {
    return description?.split(/(?<=[.!?])\s+|\n/)
        .map(line => line.replace(/^[\d+.\-*+•]/, '').trim());
}

//#endregion